import { Action } from '@wix/component-protocol/schema';
import { IEditActionSource } from '../types';
import { compose } from 'lodash/fp';
import { filterActionsByDataBindingOverrides } from '../dataBindingOverrides';
import {
  EditActionsDictionary,
  NativeActionNames,
} from '@wix/editor-platform-host-integration-apis';
import { editActionsValidators } from './validators';
import { CompRef } from '@wix/document-services-types';
import type { EditorPointer } from '@wix/editor-document-logic-api';

type Actions = Partial<Record<NativeActionNames, Action>>;

export class NativeActionSource extends IEditActionSource<NativeActionNames> {
  private deriveDefaultEditActionsFromManifest(
    editorPointers: EditorPointer<CompRef>[],
  ): EditActionsDictionary<Action> {
    return Object.fromEntries(
      Object.entries(editActionsValidators)
        .filter(([, validate]) =>
          validate(this.ctx.componentsAPI, editorPointers),
        )
        .map(([actionName]) => [actionName, { actionName }]),
    ) as EditActionsDictionary<Action>;
  }

  getDefinitions(): Actions {
    const { componentsAPI, editorPointers } = this.ctx;

    const definitions = {
      ...(componentsAPI.components.getEditActions(editorPointers) || {}),
      ...(this.deriveDefaultEditActionsFromManifest(editorPointers) || {}),
    };

    const filterNativeActions = compose<[Actions], Actions, Actions>(
      (actions) =>
        filterActionsByDataBindingOverrides(actions, this.ctx) as Actions,
      (actions) =>
        componentsAPI.editActions.applyDisplayFilters(
          editorPointers,
          actions,
        ) as Actions,
    );

    return filterNativeActions(definitions);
  }
}
